import { registerLoginButtonElement } from './loginButtonElement'

export { configureZIdentity } from './config'
export type { ZIdentityConfig } from './config'
export { buildAuthorizeUrl } from './authorizeUrl'
export type { AuthorizeUrlParams } from './authorizeUrl'
export { renderLoginButton } from './loginButton'
export type { RenderLoginButtonOptions } from './loginButton'
export {
  LOGIN_BUTTON_TAG_NAME,
  registerLoginButtonElement,
  ZidentityLoginButtonElement,
} from './loginButtonElement'
export { prompt2FA, StepUpError } from './stepUp'
export type { StepUpOptions, StepUpResult, StepUpErrorCode, SubmitCodeParams } from './stepUp'

registerLoginButtonElement()
